import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import LoadingAnimation from '../../../../components/LoadingAnimation'
import { getListOfEvidence } from '../../../../reducers/manageFacts'
import {Button, Checkbox, Input} from "antd";
import {Modal} from "react-bootstrap";
// import CreateUpdateEvidence from "../../../library/components/CreateUpdateEvidence";


export default function StepTwo({ indications, supporting_evidence, onChangeEvidence, ...props }) {
  // REDUX
  const dispatch = useDispatch()
  const listOfEvidence = useSelector(state => state.manageFacts.listOfEvidence)
  const fetchingListOfEvidence = useSelector(state => state.manageFacts.fetchingListOfEvidence)

  // STATE
  const [searchTerm, setSearchTerm] = useState("")

  useEffect(() => {
    const indicationIDs = indications.map(indication => {
      indication = indication.split("/")
      return indication[indication.length - 2]
    })

    dispatch(getListOfEvidence(indicationIDs))
  }, [])

  const handleSearch = (e) => {
    e.preventDefault()
    const indicationIDs = indications.map(indication => {
      indication = indication.split("/")
      return indication[indication.length - 2]
    })
    dispatch(getListOfEvidence(indicationIDs, searchTerm))
  }

  let evidences = listOfEvidence.map((evidence, index) => {
    return (
      <tr key={ index }
        className="kvm-label"
        onClick={(e) => {
          e.preventDefault()
          onChangeEvidence(evidence.url)
        }}
        >
        <td>
          <Checkbox
            // type="checkbox"
            id={ `evidence-${evidence.id}` }
            checked={ !!supporting_evidence.find(evidenceObject => evidenceObject.id === evidence.id || evidence.url === evidenceObject) }
            onChange={() => null}
            onClick={(e) => {
              e.stopPropagation()
              onChangeEvidence(evidence.url)
            }}
          />
        </td>
        <td style={{ maxWidth: '20vw', width: '100%', overflow: 'hidden' }}>
          <label
            className="kvm-message"
            htmlFor={ `evidence-${evidence.id}` }
          >
            { evidence.full_reference }
          </label>
        </td>
      </tr>
    )
  })

  if (!evidences.length) {
    evidences = (
      <tr className="kvm-label">
        <td></td>
        <td style={{ maxWidth: '20vw', width: '100%', overflow: 'hidden' }}>
          There are no evidences for the selected indications...
        </td>
      </tr>
    )
  }

  return (
    <React.Fragment>
      <Modal.Body>
        <div id="newfact" className="translucent-background-with-padding">
          <p className="title">
            <strong>Select Evidence:</strong>
          </p>
          <div>
          </div>
          <center style={{ marginBottom: "10px" }}>
            <form onSubmit={ handleSearch }>
              <Input
                value={ searchTerm }
                onChange={ (e) => setSearchTerm(e.target.value) }
                placeholder="Search..."
              />
              </form>
          </center>
          <div>
            <table className="evidencetable">
              <thead>
                <tr>
                  <th className="label"></th>
                  <th className="label">
                    Select from Existing Evidence
                  </th>
                </tr>
              </thead>
              <tbody>
                { fetchingListOfEvidence ?
                <tr className="kvm-label">
                  <td></td>
                  <td style={{ maxWidth: '20vw', width: '100%', overflow: 'hidden', padding: "100px" }}>
                    <br/>
                    <LoadingAnimation />
                  </td>
                </tr>
                : evidences }
              </tbody>
            </table>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button key="1" onClick={ props.handleCancel }>Cancel</Button>
        <Button key="2" onClick={ () => props.changeStep(1) }>Back</Button>
        <Button key="3" onClick={ () => props.changeStep(3) }>Select Categories</Button>
      </Modal.Footer>
    </React.Fragment>
  )
}